
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/store-directory",
      function () {
        return require("private-next-pages/docs/how-to/store-directory.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/store-directory"])
      });
    }
  